import { createSlice } from '@reduxjs/toolkit';

import { Api } from './Api';
import { ConfigState } from './types';

export const initialAuthState: ConfigState = {
  workTime: {
    open: 0,
    closed: 23
  }
};

const configSlice = createSlice({
  name: 'config',
  initialState: initialAuthState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(Api.endpoints.getWorkTime.matchFulfilled, (state: ConfigState, action) => {
        state.workTime = action.payload;
      });
  },
});

export { configSlice };

export const selectWorkTime = (state: RootState) => state.config.workTime;
